<template>
  <div>
    <div class="container">
      <div class="content-section">
        <h3>
          新余3D技术科普体验馆
          <!-- <div>三维创新设计及其编程教育引领者</div> -->
        </h3>
        <div class="slide" v-html="gymnasiumDetail[view].detail" >
          
        </div>
        <div>
          <img
            :src="gymnasiumDetail[view].imageUrl"
            style="border-radius: 16px; width: 100%; heigth: 300px"
          />
        </div>
        <!--<h4>合伙人与团队</h4>-->
      </div>
      <div class="content-section" style="margin-top: 2">
        &nbsp;<br />&nbsp;<br />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "about",
  data() {
    return {
      gymnasiumDetail: [
        {
          detail: `<p>
            &nbsp;&nbsp;&nbsp;&nbsp;
            新余3D技术科普体验馆是由清华大学、新余市政府和新余清软海芯公司共同建造。展馆分为上下两层，总面积约2500平米。
            新余3D技术科普体验馆向社会免费开放。<br />

            开放时间：<br />
            1、周二至周日 上午：9:00 - 12:00 下午：13:30 - 17:00
            <br />
            2、周一闭馆
            <br />
            3、法定节日另行通知
            <br />
            预约电话： 0790-6866618
          </p>`,
          imageUrl: "/static/xinyu.jpg",
        },
         {
          detail:  `<p>
            &nbsp;&nbsp;&nbsp;&nbsp;
            云浮3D科普体验馆是由清华大学、云浮市政府和云浮清软海芯科技有限公司共同建造。总面积约1500平米。 云浮3D科普体验馆向社会免费开放。<br />

            开放时间：<br />
            1、周二至周日 上午：9:00 - 11:30 下午：13:30 - 17:00
            <br />
            2、周一闭馆
            <br />
            3、法定节日另行通知
            <br />
            预约电话： 0766-8297881
          </p>`,
          imageUrl: "/static/yunfu.jpg",
        }
      ],
      view:0
    };
  },
           created() {
               
               this.view  = this.$route.query.view;
               console.log(this.view)
            }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.slide {
  background: #f0f0f0;
  padding: 2em 3em;
  margin-top: 2em;
  margin-bottom: 2em;
  line-height: 32px;
  border: solid 1px #ddd;
  border-radius: 16px;
  font-size: 18px;
  font-weight: 100;
}
.slide b {
  color: #0078d7;
}
.content-section {
}
.content-section .text {
  margin-left: 40px;
  color: #666;
  font-weight: 100;
  line-height: 1.7em;
}
.content-section ol {
  list-style: disc;
}
.content-section h3 {
  font-weight: 100;
  font-size: 48px;
  padding-left: 16px;
  border-left: solid 10px #b2d9e1;
}
.content-section h3 div {
  font-size: 36px;
  color: #666;
}
.code-rect {
  border-radius: 16px;
  border: solid 1px #ccc;
}
.code {
  font-family: Courier;
  font-weight: bold;
}
.code .k {
  font-weight: bold;
  color: #00f;
}
.code .n {
  color: #c00;
}
.formula {
  vertical-align: middle;
  text-align: center;
}
.formula .item {
  display: inline-block;
  border-radius: 8px;
  border: solid 1px #ccc;
  padding: 0.8em;
  text-align: center;
  vertical-align: middle;
  background-color: #f84;
  color: white;
}
.formula .symbol {
  display: inline-block;
  vertical-align: middle;
  font-size: 36px;
  font-weight: 400;
}
.formula span {
  font-size: 14px;
}
table th {
  padding: 0.8em 1em;
  border-bottom: solid 1px #ccc;
  color: #f84;
  font-size: 18px;
  text-align: left;
}
table td {
  padding: 0.5em 1em;
  text-align: left;
  font-size: 14px;
}
h4 {
  font-size: 38px;
  color: #a19063;
  font-weight: 100;
}
</style>



// WEBPACK FOOTER //
// src/components/gymnasiumDetail.vue